<template>
    <div class="page page-personal-center">
        <div class="user-info-header page-content">
            <div class="user-image">
                <img :src="userHeadAvatar" alt="" />
            </div>
            <div class="user-header-text">
                <p class="title-name fontsize-24">
                    {{ userData.name }}
                    <span v-if="userData.level" class="level-span inline-block marginL10">{{ userData.level }}</span>
                </p>
                <p v-if="oauth.userFrom === 0">
                    <i class="iconfont icon-bumen color1"></i>
                    {{ userData.orgPathName }}
                </p>
                <p v-if="oauth.userFrom === 0">
                    <i class="iconfont icon-gangwei color2"></i>
                    {{ userData.positionName }}
                </p>
                <p v-if="oauth.userFrom === 1 && userData.company">
                    <i class="iconfont icon-bumen color1"></i>
                    {{ userData.company }}
                </p>
            </div>
        </div>
        <div class="user-info">
            <personInfo></personInfo>
        </div>
    </div>
</template>

<script>
import personInfo from "./components/person-info";
import { mapState, mapGetters } from "vuex";
export default {
    components: {
        personInfo,
    },
    computed: {
        ...mapState({
            userData: (state) => state.user.userData,
            oauth: (state) => state.user.oauth,
        }),
        ...mapGetters({
            userHeadAvatar: "userHeadAvatar",
        }),
    },
};
</script>

<style lang="scss" scoped>
.page-personal-center {
    height: 100%;
}
.user-info {
    height: 100%;
}
.user-info-header {
    background: rgba(245, 247, 250, 1);
    display: flex;
    .user-image {
        display: inline-block;
        width: 80px;
        height: 80px;
        margin-top: 10px;
        img {
            display: inline-block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
    .title-name {
        color: #333;
    }
    .user-header-text {
        padding-left: 20px;
        line-height: 1.6;
        color: #666666;
        .iconfont {
            display: inline-block;
            margin-right: 8px;
        }
        .color1 {
            color: #37d2f0;
        }
        .color2 {
            color: #c891ef;
        }
    }
}
.level-span {
    line-height: 18px;
    height: 20px;
    font-size: 12px;
    font-weight: 500;
    background: #f27095;
    border: 1px solid white;
    border-radius: 10px;
    color: white;
    padding: 0 8px;
    vertical-align: middle;
    margin-bottom: 7px;
}
</style>
